var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      staticClass: "home-form-container elevation-2",
      attrs: {
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        "min-height": 217,
        active: true,
        parent: true,
        resizable: true,
        "class-name-handle": "object-form-resizable-handle",
        "drag-handle": ".drag",
        "data-app": ""
      },
      on: { resizing: _vm.onResizing }
    },
    [
      _c("multiple-objects-selected-window", {
        attrs: {
          "is-multi-select": true,
          tabs: _vm.tabs,
          "active-tab": _vm.activeTab,
          height: _vm.height,
          width: _vm.width
        },
        on: { closeForm: _vm.tryCloseForm, startTabChange: _vm.startTabChange }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.changeTabDialogIsOpen,
          title: _vm.$t("ChangeTab"),
          content:
            _vm.$t("UnsavedChanges") +
            "\n" +
            _vm.$t("CheckTabChange") +
            "\n" +
            _vm.$t("ChangesWillBeLost"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.changeTabDialogIsOpen = false
          },
          secondaryAction: _vm.confirmTabChange
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.closeDialogIsOpen,
          title: _vm.$t("ClosingForm"),
          content:
            _vm.$t("UnsavedChanges") +
            "\n" +
            _vm.$t("CheckCloseForm") +
            "\n" +
            _vm.$t("ChangesWillBeLost"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.closeDialogIsOpen = false
          },
          secondaryAction: function($event) {
            return _vm.closeForm()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-275e5ae2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-275e5ae2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/MultiSelectionForm/MultiSelectionForm.vue
// module id = null
// module chunks = 